var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWidescreen = function SvgWidescreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M8.66666667,22 C9.55555556,21.3333333 10,20.6666667 10,20 L3,20 C1.8954305,20 1,19.1045695 1,18 L1,3 C1,1.8954305 1.8954305,1 3,1 L21,1 C22.1045695,1 23,1.8954305 23,3 L23,18 C23,19.1045695 22.1045695,20 21,20 L14,20 C14,20.6666667 14.4444444,21.3333333 15.3333333,22 L18.5,22 C18.7761424,22 19,22.2238576 19,22.5 C19,22.7761424 18.7761424,23 18.5,23 L5.5,23 C5.22385763,23 5,22.7761424 5,22.5 C5,22.2238576 5.22385763,22 5.5,22 L8.66666667,22 Z M2,3 L2,16 L22,16 L22,3 L2,3 Z M15,6 L18,9 L15,12 L15,10 L9,10 L9,12 L6,9 L9,6 L9,8 L15,8 L15,6 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWidescreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Widescreen.de489550.svg";
export { ForwardRef as ReactComponent };